<template>
  <v-container fluid class="billmaterial-list mt-3">
    <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" sm="12" md="12" lg="12" class="d-flex justify-space-between justify-md-start overflow-auto">
              <v-btn to="/billmaterial/add" color="success" class="button-shadow mr-3">
                <v-icon class="mr-2">mdi-plus</v-icon>
                Add
              </v-btn>
              <v-btn color="success" class="button-shadow mr-3" @click="findBillMaterialDialog=true">
                <v-icon class="mr-2">mdi-file-search</v-icon>
                Find
              </v-btn>
              <v-btn color="primary" class="button-shadow mr-3" @click="makeDepositList">
                <v-icon class="mr-2">mdi-cash-plus</v-icon>
                Deposit
              </v-btn>
              <download-excel
                class="btn btn-default"
                :data="getJson()"
                worksheet="My Worksheet"
                type="xls"
                :name="getFileName()"
              >
              <v-btn 
                v-show="dataOrders.length>0"
                color="default" 
                class="button-shadow mb-2 mr-0 mr-sm-2"
              >
                <v-icon class="mr-2">mdi-microsoft-excel</v-icon>
                Save
              </v-btn>
              </download-excel>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="ma-1">
          <v-card-text>
            <v-data-table
              show-select
              sort-desc
              item-key="_id"
              v-model="dataSelected"
              loading-text="Loading... Please wait"
              class="billmaterials-table"
              sort-by="billmaterialnum"
              :loading="isReceiving || isDeleting"
              :footer-props="footer"
              :headers="headers"
              :items="dataOrders"
              :items-per-page="itemPerPage">
              <template v-slot:top>
                <v-dialog
                  v-model="dialog"
                  width="500"
                >
                  <v-card>
                    <v-card-title>
                      Delete this Bill of Material?
                    </v-card-title>
                    <v-card-text>
                      {{ deletebillmaterial.billmaterialnum }} 
                      {{ deletebillmaterial.billmaterialname }}
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" outlined @click="dialog = false">Cancel</v-btn>
                      <v-btn color="secondary" class="button-shadow" @click="deleteItem(deletebillmaterial)">Delete</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </template>
              <template v-slot:item.userid="{ item }">
                <div v-if="item.userid!=undefined">
                <v-avatar v-if="users.length>0 && users.find(user=>user._id == item.userid)['userimage']!==''" size="40">
                  <img v-bind:src="users.find(user=>user._id == item.userid)['userimage']" alt="">
                </v-avatar>
                <v-avatar
                  v-else
                  color="warning"
                  size="40">
                  <span class="white--text headline">{{ users.length>0 ? users.find(user=>user._id == item.userid)['username'][0].toUpperCase() : '' }}</span>
                </v-avatar>
                <span style="margin-left:15px">{{ users.length>0 ? users.find(user=>user._id == item.userid)['username'] : '' }} </span>
                </div>
              </template>
              <template v-slot:item.billmaterialimage="{ item }">
                    <v-img
                    v-if="item.billmaterialimage" 
                    v-bind:src="item.billmaterialimage"
                    max-height="100"
                    max-width="100"
                  ></v-img>
              </template>
              <template v-slot:item.billmaterialnum="{ item }">
                
                <p class="two-line">{{ item.billmaterialtype  }}</p>
                <p class="two-line">{{ item.billmaterialnum  }}</p>
                <p v-if="item.billmaterialdate!=undefined" class="two-line">{{ new Date(item.billmaterialdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric' })  }}</p>
              </template>
              <template v-slot:item.billmaterialname="{ item }">
                <p class="two-line">{{ item.billmaterialname }}</p>
                <p class="two-line">{{ item.billmaterialaddress }}</p>
                <p v-if="item.regionid!=undefined && item.locationid!=undefined" class="two-line">{{ regions.length>0 ? regions.find(region=>region._id == item.regionid)['regionname'] : ''  }} - {{ locations.length>0 ? locations.find(location=>location._id == item.locationid)['locationname'] : ''  }} - {{ item.customertype }}</p>
              </template>
              <template v-slot:item.billmaterialtotal="{ item }">
                <p class="two-line">{{ item.billmaterialtotal.toLocaleString('en-SG') }}</p>
                <p v-if="item.paymethodid!=null" class="two-line">{{ paymethods.length>0 ? paymethods.find(method=>method._id == item.paymethodid)['paymethodcode'] : ''  }}</p>
              </template>
              <template v-slot:item.billmaterialstatus="{ item }">
                <v-chip
                  v-if="item.billmaterialstatus!=undefined"
                  :color="item.billmaterialstatus=='Completed' ? 'successConst white--text' : item.billmaterialstatus=='Partial' ? 'warning white--text' : 'secondaryConst white--text'" small>
                  {{ item.billmaterialstatus }}
                </v-chip>
              </template>
              <template v-slot:item.createdAt="{ item }">
                {{ new Date(item.createdAt).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}
              </template>
              <template v-slot:item.actions="{ item }">
                <div v-if="item._id!=undefined">
                <v-btn icon color="primary" @click="viewItem(item)">
                  <v-icon>mdi-magnify</v-icon>
                </v-btn>
                <v-btn icon color="primary" @click="editItem(item)">
                  <v-icon>mdi-pencil-outline</v-icon>
                </v-btn>
                <v-btn icon color="primary" @click="printItem(item)">
                  <v-icon>mdi-printer</v-icon>
                </v-btn>
                <v-btn v-if="item.billmaterialstatus!=='Completed'" icon color="primary" @click="deleteDialog(item)">
                  <v-icon>mdi-delete-outline</v-icon>
                </v-btn>
                </div>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row justify="center">
    <v-dialog
      v-model="findBillMaterialDialog"
      persistent
      max-width="600px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Find Bill of Materials</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-select
                  :items="locations.filter(x=>x.locationstatus=='Active').map(x => {
                            return {text: x.locationname, value: x._id};
                          })"
                  v-model="query.locationid"
                  label="Location"
                  required
                ></v-select>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                        <v-menu
                          ref="menu_startdate"
                          v-model="menu_startdate"
                          :close-on-content-click="false"
                          :return-value.sync="query.startdate"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              outlined
                              dense
                              v-model="query.startdate"
                              label="Start Date"
                              v-bind="attrs"
                              v-bind:value="query.startdate"
                              v-on="on"
                              persistent-hint
                              single-line hint="Please enter start date">
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="query.startdate"
                            no-title
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="menu_startdate = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="$refs.menu_startdate.save(query.startdate)"
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-menu
                  ref="menu_enddate"
                  v-model="menu_enddate"
                  :close-on-content-click="false"
                  :return-value.sync="query.enddate"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                     outlined
                     dense
                     v-model="query.enddate"
                     label="End Date"
                     v-bind="attrs"
                     v-bind:value="query.enddate"
                     v-on="on"
                     persistent-hint
                    single-line hint="Please enter end date">
                  ></v-text-field>
                </template>
                <v-date-picker
                            v-model="query.enddate"
                            no-title
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="menu_enddate = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="$refs.menu_enddate.save(query.enddate)"
                            >
                              OK
                            </v-btn>
                    </v-date-picker>
                  </v-menu>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="findBillMaterialDialog = false"
          >
            Close
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="resetBillMaterials"
          >
            Reset
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="findBillMaterials"
          >
            Find
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
  <div class="text-center">
    <v-dialog
      v-model="dialogAlert"
      width="300"
    >
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">Error</v-card-title>
        <v-card-text>
          {{ dialogMessage }}
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="dialogAlert = false"
          >
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
  </v-container>
</template>

<script>
import config from "../../../config"
import { mapState, mapActions } from 'vuex'

export default {
  name: 'BillMaterialList',
  data() {
    return {
      config,
      snackbar: null,
      dialog: false,
      dialogAlert: false,
      dialogMessage: '',
      findBillMaterialDialog: false,
      menu_startdate: null,
      menu_enddate: null,
      itemPerPage: 500,
      deletebillmaterial: {},
      query: {},
      footer: {'items-per-page-options': [500, 1000, 5000]},
      headers: [
        { text: 'Image', value: 'billmaterialimage', sortable: false },
        { text: 'Order', value: 'billmaterialnum', sortable: false },
        { text: 'Name', value: 'billmaterialname' },
        { text: 'Amount', value: 'billmaterialtotal' },
        { text: 'User', value: 'userid' },
        { text: 'Status', value: 'billmaterialstatus' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      dataOrders: [],
      dataSelected: [],

    }
  },
  computed: {
    ...mapState('BillMaterial', ['billmaterials', 'isReceiving', 'isDeleting','billmaterialsMessage']),
    ...mapState('PayMethod', ['paymethods']),
    ...mapState('Region', ['regions']),
    ...mapState('Location', ['locations']),
    ...mapState('User', ['users']),
  },
  methods: {
    ...mapActions('BillMaterial', ["getBillMaterialsRequest", "getBillMaterialQueryRequest", "deleteBillMaterialRequest","updateBillMaterialRequest","createBillMaterialRequest"]),
    ...mapActions('PayMethod', ["getPayMethodsRequest"]),
    ...mapActions('Region', ["getRegionsRequest"]),
    ...mapActions('Location', ["getLocationsRequest"]),
    ...mapActions('User', ["getUsersRequest"]),
    getJson(){
      let json = this.dataOrders.map(order=>{return {
        ordernum: order.billmaterialnum, 
        orderdate: order.billmaterialdate!=undefined ? new Date(order.billmaterialdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) : '',
        ordertime: order.billmaterialdate!=undefined ? new Date(order.billmaterialdate).toLocaleString("en-SG", { hour: 'numeric', minute: 'numeric' }) : '',
        ordertype: order.billmaterialtype,
        name: order.billmaterialname, 
        address: order.billmaterialaddress,
        region: order.regionid!=undefined && this.regions.length>0 ? this.regions.find(region=>region._id == order.regionid)['regionname'] : '',
        location: order.locationid!=undefined && this.locations.length>0 ? this.locations.find(town=>town._id == order.locationid)['locationname'] : '',
        customertype: order.customertype,
        rep: order.userid!=undefined && this.users.length>0 ? this.users.find(user=>user._id == order.userid)['username'] : '',
        paymentmethod: order.paymethodid!=undefined && this.paymethods.length>0 ? this.paymethods.find(method=>method._id == order.paymethodid)['paymethodname'] : '',
        tax: order.billmaterialtaxamount,
        subtotal: order.billmaterialsubtotal,
        total: order.billmaterialtotal,
        rate: order.currencyRate,
      }});
      return json;
    },
    checkError(){
      if(this.dataSelected.length==0) return false;
      if(this.dataSelected.find(item=>item.billmaterialstatus=='Completed')!=null) return false;
      return true;
    },
    checkBillMaterials(){
      return this.dataSelected.filter(item=>item.billmaterialstatus=='Completed').map(item=>item.billmaterialnum.toString()).join(', ');
    },
    getFileName(){
      var d = new Date();
      var name = 'sales-orders-' + d.getFullYear() + '-' + (d.getMonth()+1).toString() + '-' + d.getDate() + '-' + (d.getHours().toString() +d.getSeconds().toString());
      return name + '.xls';
    },
    makeDepositList(){
      if(!this.checkError()) {
        if(this.dataSelected.length==0) this.dialogMessage='No BillMaterials selected';
        else this.dialogMessage='The following BillMaterials cannot be deposited:  ' + this.checkBillMaterials();
        this.dialogAlert=true; 
        return;
      }
      let orders = Object.assign([], this.dataSelected);
      let json = {orders: orders, isBillMaterials: true};
      this.$router.push({ name: 'DepositAdd', params: json });
    },
    editItem(item) {
      this.$router.push({ name: 'BillMaterialEdit', params: item });
    },
    printItem(item) {
      this.$router.push({ name: 'BillMaterialPrint', params: item });
    },
    viewItem(item) {
      this.$router.push({ name: 'BillMaterialView', params: item });
    },
    async findBillMaterials(){
      this.findBillMaterialDialog = false;
      if(this.query=={}){
        await this.getBillMaterialsRequest();
        this.dataOrders = Object.assign([], this.billmaterials);
        this.dataOrders.push({billmaterialtotal: this.billmaterials.reduce(function (last, json) {return last + json.billmaterialtotal;}, 0) });
      }
      else{
        let result = await this.getBillMaterialQueryRequest(this.query);
        this.dataOrders = Object.assign([], result);
        this.dataOrders.push({billmaterialtotal: result.reduce(function (last, json) {return last + json.billmaterialtotal;}, 0) });
      }
    },
    async resetBillMaterials(){
      this.query = {};

    },
    async deleteItem(item) {
      await this.deleteBillMaterialRequest({_id: item._id});
      this.dataOrders = this.billmaterials;
      this.dialog = false;
    },
    deleteDialog(item) {
      this.dialog = true;
      this.deletebillmaterial = {
        _id: item._id,
        billmaterialnum: item.billmaterialnum,
        billmaterialname: item.billmaterialname,
      }
    },
  },
  async created () {
    if(this.$route.params.isDeposit==true) this.dataSelected = this.$route.params.orders;
    if(this.billmaterials.length==0) await this.getBillMaterialsRequest();
    this.dataOrders = Object.assign([], this.billmaterials);
    this.dataOrders.push({billmaterialtotal: this.billmaterials.reduce(function (last, json) {return last + json.billmaterialtotal;}, 0) });
    if(this.locations.length==0) await this.getLocationsRequest();
  },
}
</script>

<style src="./List.scss" lang="scss"></style>
